import type MockAdapter from 'axios-mock-adapter'
import { currentUserId } from '../engine/context'
import { fail, handle, parse, roleCodesOf } from './c07.shared'
import {
  listNotifications,
  markAllNotificationsRead,
  markNotificationsRead,
  type NotificationListParams,
  unreadNotificationCount
} from './notification.shared'

/** Salinan server `NOTIFICATION_ALL_SCOPE_ROLES` (service-library, DECISIONS D5) — kesamaan dijaga uji. */
export const NOTIFICATION_ALL_SCOPE_ROLES = [
  'admin_wh_rm',
  'admin_wh_sansugi',
  'admin_wh_fg',
  'wh_rm_supervisor',
  'supervisor_wh_fg',
  'kadiv_wh_rm',
  'kadiv_wh_fg'
] as const

/** Daftar GEN-03; `scope=all` hanya untuk Admin, Supervisor dan Kadiv (403 untuk role lain). */
export function listNotificationsFor(params: NotificationListParams = {}) {
  const allowed = roleCodesOf(currentUserId()).some(code =>
    (NOTIFICATION_ALL_SCOPE_ROLES as readonly string[]).includes(code)
  )
  if (params.scope === 'all' && !allowed)
    fail('Tab Semua Persona hanya untuk Admin, Supervisor dan Kadiv.', 'ERR_UNAUTHORIZED_ROLE', 403)
  return listNotifications(params)
}

/**
 * Pusat Notifikasi (GEN-03, JAL-PG-40-002; BA 17B §2 "CORE /notifications: read, read-all") — endpoint custom
 * `/api/v1/wms/notifications`. Terbatas pada notifikasi milik user aktif, kecuali `scope=all` (tab "Semua Persona",
 * DECISIONS D5). Pembuatan notifikasi tidak lewat HTTP:
 * handler lain memanggil `notify()` (lihat `notification.shared.ts`) atau aturan workflow (`notification.rules.ts`).
 */
export function registerNotificationHandlers(mock: MockAdapter) {
  const base = '/api/v1/wms/notifications'
  mock.onGet(`${base}/unread-count`).reply(() => handle(() => unreadNotificationCount()))
  mock.onGet(base).reply(config => handle(() => listNotificationsFor((config.params ?? {}) as NotificationListParams)))
  mock.onPost(`${base}/read-all`).reply(() => handle(() => markAllNotificationsRead()))
  mock
    .onPost(`${base}/read`)
    .reply(config => handle(() => markNotificationsRead(parse<{ ids?: string[] }>(config.data))))
}
